export default __webpack_public_path__ + "static/media/IMG_0024_5_11zon.38a74f10.jpg";